// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3WDCd","imageUploader":"EGiftCard_imageUploader__1tFSy"};